const constants = {
    CURRENT_USER: 'FLEX.CURRENTUSER',
    TOKEN_KEY: 'FLEX.TOKEN',
    REFRESH_TOKEN_KEY: 'FLEX.REFRESH_TOKEN',
    DOMAIN: '192.168.29.167' //'192.168.29.167'
}

export default constants